import React from 'react'
import { concatClientAndProjectName } from '../../../types/Engagement'

interface Props {
  projectName: string
  clientName: string
  teamName: string
  readOnly?: boolean
  handleEngagementClick: (event: React.MouseEvent) => void
}

const ProjectName = ({
  projectName,
  clientName,
  teamName,
  readOnly = false,
  handleEngagementClick,
}: Props) => {
  const subtitle = concatClientAndProjectName(clientName, projectName)

  return (
    <div>
      <div className="tribe-org__engagement-title">{teamName}</div>
      <div
        className={`tribe-org__engagement-subtitle${
          !readOnly && projectName
            ? ' tribe-org__engagement-subtitle--clickable'
            : ''
        }`}
        style={{
          cursor: !readOnly && projectName ? 'pointer' : 'default',
        }}
        onClick={readOnly ? undefined : handleEngagementClick}
      >
        {subtitle}
      </div>
    </div>
  )
}

export default ProjectName
